import React from 'react';
export function Bonuses() {
  const bonuses = [{
    title: 'Checklist de Clase de Emergencia',
    value: '9€'
  }, {
    title: 'Guía de Selección Musical PRO',
    value: '12€'
  }, {
    title: 'Fichas de Seguimiento y Progreso',
    value: '7€'
  }, {
    title: 'Syllabus de 12 Semanas',
    value: '14€'
  }, {
    title: 'Plantillas de Marketing y Copy',
    value: '5€'
  }, {
    title: 'Diccionario de Terminología PRO',
    value: '2,90€'
  }];
  return <section className="bg-black py-12 px-4" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4 text-center" data-id="element-34">
          🔥 6 Bonos Exclusivos Incluidos
        </h2>
        <p className="text-center text-white font-medium mb-12 font-heading" data-id="element-35">
          Valor combinado: 49,90€ — Gratis hoy
        </p>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-36">
          {bonuses.map((bonus, i) => <div key={i} className="flex items-center justify-between p-4 rounded-lg border border-white/20 hover:border-white/40 transition-colors bg-white/5" data-id="element-37">
              <span className="text-white" data-id="element-38">{bonus.title}</span>
              <span className="text-brand-cta font-medium" data-id="element-39">{bonus.value}</span>
            </div>)}
        </div>
      </div>
    </section>;
}